import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'app-jobseeker-dialog',
  templateUrl: './jobseeker-dialog.component.html',
  standalone: false,
})
export class JobseekerDialogComponent {
  @Input() jobseeker: any;             // Recibe el candidato seleccionado
  @Input() visible = false;            // Controla si está abierto
  @Output() closed = new EventEmitter<void>(); // Evento al cerrar

  seccionesJustificacion: { [key: string]: string } = {};

  ngOnChanges() {
  if (this.jobseeker?.justificacion != null) {
    if (this.jobseeker.justificacion.trim() === '') {
      this.seccionesJustificacion = {};
    } else {
      this.parseJustificacion(this.jobseeker.justificacion);
    }
  } else {
    this.seccionesJustificacion = {};
  }
}


  parseJustificacion(motivo: string) {
    const secciones = [
      'EXPERIENCIA',
      'FORMACI[ÓO]N',
      'COMPETENCIAS',
      'VALORACI[ÓO]N GENERAL'
    ];

    const resultado: Record<string, string> = {};

    secciones.forEach((sec, i) => {
      const nextSec = secciones[i + 1];

      const regex = nextSec
        ? new RegExp(`${sec}\\s*([\\s\\S]*?)(?=${nextSec})`) 
        : new RegExp(`${sec}\\s*([\\s\\S]*)`);

      const match = motivo.match(regex);
      let texto = match?.[1]?.trim() ?? '';

      texto = texto.replace(/[#:]/g, '').trim();

      resultado[sec.replace(/\[ÓO\]/, 'Ó')] = texto;
    });

    this.seccionesJustificacion = resultado;
  }

  closeDialog(): void {
    this.visible = false;
    this.closed.emit();
  }
}
